<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs v-model="search.pay_Baddress"
      pills
      class="mb-4"
      @input="changeRegional()"
    >
      <b-tab
        v-for="(item, index) in options.regional"
        :key="index"
        :title="item.label"
      />
    </b-tabs>

    <tables-page
      :tableData="statistics.table_data"
      :tableFields="statistics.table_fields"
      class="mb-4"
    >
      <template #thead-top>
        <b-tr>
          <b-th class="statistics-thead-title" colspan="4">各組相關數據</b-th>
        </b-tr>
      </template>

      <template #cell(total)="row">
        <span class="link" @click="getMember(null, '', '', row.item.status)">{{ row.item.total }}</span>
      </template>
    </tables-page>

    <tables-page
      :tableData="contract.table_data"
      :tableFields="contract.table_fields"
      :pageData="contract.page"
      @result="getMember"
    >
      <template #thead-top>
        <b-tr>
          <b-th class="contract-thead-title" colspan="6">
            [{{ options.regional.find(item => item.value === search.pay_Baddress).label }}] 契約名冊
            <b-badge variant="warning">
              <template v-if="search.status === 0">正常</template>
              <template v-else-if="search.status === 1">身故</template>
              <template v-else-if="search.status === 2">停效</template>
              <template v-else-if="search.status === 3">除會</template>
              <template v-else-if="search.status === 4">墊繳</template>
              <template v-else>全部</template>
            </b-badge>
          </b-th>
        </b-tr>
      </template>
    </tables-page>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import { RocCountyInfo } from "@/models/HELPERS/utilitiesData.js";

export default {
  name: 'regionalDataReport',
  components: {
    BreadCrumb,
    TablesPage
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '地區相關數據', url: '', isActive: false }
        ]
      },
      options: {
        regional: [],
      },
      search: {
        pay_Baddress: 0,
        status: ''
      },
      statistics: {
        table_fields: [
          {
            key: "group",
            label: "組別",
          },
          {
            key: "a",
            label: "A：永保",
          },
          {
            key: "b",
            label: "B：長安",
          },
          {
            key: "total",
            label: "合計",
          }
        ],
        table_data: []
      },
      contract: {
        table_fields: [
          {
            key: "number",
            label: "契約編號",
            sortable: true
          },
          {
            key: "member_name",
            label: "互助人",
            sortable: true
          },
          {
            key: "member_ID_number",
            label: "身分證",
            sortable: true
          },
          {
            key: "pay_Baddress",
            label: "帳單地址",
            sortable: true
          },
          {
            key: "sales_number",
            label: "業務編號",
            sortable: true
          },
          {
            key: "sales_name",
            label: "業務姓名",
            sortable: true
          },
        ],
        table_data: [],
        table_sort: {
          sortBy: '',
          sort: ''
        },
        page: {},
      }
    }
  },
  computed: {

  },
  mounted() {
    this.reportApi = new reportApi();
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.contract.page = Object.assign({}, this.contractApi.page);
      this.regionalOptionsHandler();
      this.getReportAllMember();
      this.getMember();
    },
    // 地區選單處理
    regionalOptionsHandler() {
      this.options.regional = RocCountyInfo.map((item, index) => {
        return {
          label: item,
          value: index + 1
        }
      });

      this.options.regional.unshift({
        label: '全部',
        value: 0
      })
    },
    // 取得契約各組相關數據總表
    getReportAllMember() {
      const pay_baddress = this.options.regional.find(item => item.value === this.search.pay_Baddress).label;
      const params = {
        'pay_Baddress': pay_baddress === '全部' ? '' : pay_baddress,
      };

      this.reportApi.getReportAllMember((response) => {
        const res = response.data;
        const data = res.data[0];

        this.statistics.table_data = [
          {
            group: '正常組數',
            a: data.member_A_status_0,
            b: data.member_B_status_0,
            total: data.member_A_status_0 + data.member_B_status_0,
            status: 0
          },
          {
            group: '身故組數',
            a: data.member_A_status_1,
            b: data.member_B_status_1,
            total: data.member_A_status_1 + data.member_B_status_1,
            status: 1
          },
          {
            group: '停效組數',
            a: data.member_A_status_2,
            b: data.member_B_status_2,
            total: data.member_A_status_2 + data.member_B_status_2,
            status: 2
          },
          {
            group: '除會組數',
            a: data.member_A_status_3,
            b: data.member_B_status_3,
            total: data.member_A_status_3 + data.member_B_status_3,
            status: 3
          },
          {
            group: '墊繳組數',
            a: data.member_A_status_4,
            b: data.member_B_status_4,
            total: data.member_A_status_4 + data.member_B_status_4,
            status: 4
          },
          {
            group: '總組數',
            a: data.member_A_total,
            b: data.member_B_total,
            total: data.member_A_total + data.member_B_total,
            status: ''
          }
        ]
      }, params)
    },
    // 查詢契約
    getMember(pageIndex = null, sortBy = '', sort = '', status = null) {
      if (sortBy) this.contract.table_sort.sortBy = sortBy;
      if (sort) this.contract.table_sort.sort = sort;

      this.search.status = status !== null ? status : this.search.status;

      const pay_baddress = this.options.regional.find(item => item.value === this.search.pay_Baddress).label;
      const params = {
        'status': this.search.status,
        'pay_Baddress': pay_baddress === '全部' ? '' : pay_baddress,
        'sortBy': this.contract.table_sort.sortBy,
        'sort': this.contract.table_sort.sort,
        'PageSize': this.contract.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.contract.page.pageIndex,
      };

      this.contractApi.getMember((response) => {
        const res = response.data;

        this.contract.page.totalCount = res.total; // 總筆數
        this.contract.table_data = res.data;
      }, params)
    },
    // 改變地區
    changeRegional() {
      this.getReportAllMember();
      this.getMember();
    }
  }
}
</script>

<style lang="scss" scoped>
.table-page {
  /deep/ table {
    thead {
      tr {
        th {
          &.statistics-thead-title {
            background: #28a745;
            color: #FFF;
            font-size: 18px;
          }
          &.contract-thead-title {
            background: #007bff;
            color: #FFF;
            font-size: 18px;
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/regionalDataReport.vue